import { useState } from 'react';
import { Button } from 'devextreme-react/button';
import { LoadIndicator } from 'devextreme-react/load-indicator';
import styles from './save-button.module.scss';
import { NotifyFailure } from '~/utils';

export function SaveButton({
  text = 'Save',
  onSave,
  onSaved,
  errorMessage = 'Error saving',
  errorPopup = true,
  validationGroup = 'validation-group',
  stylingMode = 'outlined',
  className = '',
  disabled = false,
  isDirty = false,
}) {
  const [isSaving, setIsSaving] = useState(false);

  const saveButtonHandler = async (e) => {
    const validationResult = e.validationGroup?.validate();
    if (validationResult && !validationResult.isValid) {
      NotifyFailure({ message: 'Please fix validation errors before continuing.' });
      return;
    }

    setIsSaving(true);
    let result;
    if (onSave) {
      try {
        result = await onSave();
      } catch (error) {
        console.error(errorMessage, error);
        setIsSaving(false);
        if (errorPopup) {
          NotifyFailure({ message: `${errorMessage}: ${error.message || error}` });
        }
        return;
      }
    }
    setIsSaving(false);
    if (onSaved) onSaved(result);
  };

  return (
    <Button
      validationGroup={validationGroup}
      type="default"
      stylingMode={stylingMode}
      elementAttr={{
        class: [
          className,
          isSaving ? styles['save-button-loading'] : '',
          isDirty ? styles['save-button-dirty'] : '',
        ].filter(Boolean).join(' '),
        'data-testid': 'save-button',
      }}
      onClick={saveButtonHandler}
      disabled={isSaving || disabled}
    >
      <LoadIndicator height={15} width={15} visible={isSaving} />
      <span className="dx-button-text">{text}</span>
    </Button>
  );
}
